// /* eslint-disable @typescript-eslint/no-explicit-any */
import Sidebar from '@components/Comman/Sidebar';
import { Button, Modal, Spin } from 'antd';
import React, { ReactNode, useEffect } from 'react';
// @ts-ignore
import { getAccessToken } from '../auth';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

const DefaultLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [openModal, setOpenModal] = React.useState<boolean>(false);
    const isLoading = useSelector((state: any) => state?.General?.loading);

    const user = useSelector((state: any) => state?.Auth);
    let userData = user?.user?.data || user?.user?.user;
    const navigate = useNavigate();
    const location = useLocation();
    let isLoggedin = getAccessToken();

    const checkLogin =()=> {
        return navigate('/login', { replace: true }); // <Navigate to="/login" replace />
    }

    useEffect(() => {
        if (!isLoggedin) {
            checkLogin()
        }
    }, [user]);

    const checkPasswordAndSetup = (userData: any) => {
        if (!userData?.isPasswordChanged) {
            if(location.pathname !== '/account') {
                setOpenModal(true);
            }
        }
        if (userData?.isPasswordChanged && !userData?.isSetupCompleted) {
            if(location.pathname !== '/setup') {
                setOpenModal(true);
            }
        }
    }

    useEffect(() => {
        if (userData && userData?.roleId === 2) {
            checkPasswordAndSetup(userData)
        }
    }, [location])

    return (
        <div className=" flex h-screen overflow-hidden">
            {/* <!-- ===== Page Wrapper Start ===== --> */}
            {isLoading ? (
                <Spin fullscreen tip="Loading..."></Spin>) :
                <div className="main">
                    {/* <side> */}
                    <Sidebar
                        sidebarOpen={false}
                        setSidebarOpen={function (arg: boolean): void {
                            throw new Error('Function not implemented.');
                        }}
                    />
                    {/* <!-- ===== Content Area Start ===== --> */}
                    <div className="mainBody">
                        {/* <!-- ===== Main Content Start ===== --> */}
                        <main className="bg-gray h-100vh">
                            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                                {children}
                            </div>
                        </main>
                        {/* <!-- ===== Main Content End ===== --> */}
                        {/* Footer */}
                        <div className="footerbusinessLanding">
                            <div className="text-center">
                                <div className="footerbusinesstext">
                                    © {new Date().getFullYear()} ReferUs , All rights
                                    reserved
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- ===== Content Area End ===== --> */}
                </div>
            }
            {/* <!-- ===== Page Wrapper End ===== --> */}

            {/* Modal to change password and setup business first */}
            <Modal
                title={<p>Please {!userData?.isPasswordChanged ? `Setup your strong / secure password!` : `setup business first to use application`}</p>}
                footer={
                    <Button size='large' type="primary" className="btn btn-primary" onClick={()=>{
                        if (userData && !userData?.isPasswordChanged) {
                            setOpenModal(false);
                            return navigate('/account', { state: { changePassword: true } });
                        }
                        if (userData && userData?.isPasswordChanged && !userData?.isSetupCompleted) {
                            setOpenModal(false);
                            return navigate('/setup', { state: '' });
                        }
                    }}>
                        Let's Complete
                    </Button>
                }
                open={openModal}
                closable={false}
                centered={true}
            >
               <div className=''>Without completing these process you won't be able to use the application!</div>
            </Modal>
        </div>
    );
};

export default DefaultLayout;
